module.exports = __webpack_public_path__ + "img/18.39a0cf5c.png";